import axios from "axios";
import config from "../../config";
import router from "@/router"; // 引入 Vue Router

const baseURL =
  process.env.NODE_ENV === "production"
    ? config.build.base_url
    : config.dev.base_url;

// 创建 Axios 实例
const instance = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? config.build.base_url
      : config.dev.base_url,
  timeout: 10000, // 设置超时时间
});

// 响应拦截器
instance.interceptors.response.use(
  response => {
    // 对响应数据做些什么
       if (response.data.msg === '请重新登录') {
      router.push('/login');
      localStorage.removeItem("token");
    }
    return response;
  },
  error => {
    // 对响应错误做些什么
    if (error.response.data.msg === '请重新登录') {
      // 如果返回的结果是“请重新登录”，则跳转到登录页面
      router.push('/login');
      localStorage.removeItem("token");
    }
    return Promise.reject(error);
  }
);

// 登录接口请求
export function login(phone, password) {
  const formData = new FormData();
  formData.append("phone", phone);
  formData.append("password", password);

  return instance.post(`${baseURL}/app/login`, formData, {
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 注册接口请求
export function register(phone, password) {
  const formData = new FormData();
  formData.append("phone", phone);
  formData.append("password", password);

  return instance.post(`${baseURL}/app/register`, formData, {
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 兑换接口请求
export function exchangeToken(data) {
  const formData = new FormData();
  formData.append("token", data.token);
  formData.append("cdk", data.cdk);
  if (data.orderNumber) {
    formData.append("orderNumber", data.orderNumber);
  }
  return instance.post(`${baseURL}/app/exchange`, formData, {
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 订单接口请求
export function createOrder(data) {
  const formData = new FormData();
  formData.append("token", data.token);
  if (data.cdk) {
    formData.append("cdk", data.cdk);
  }
  return instance.post(`${baseURL}/app/orders`, formData, {
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 查看令牌
export function generateGuardCode(data) {
  const formData = new FormData();
  formData.append("token", data.token);
  formData.append("orderNumber", data.orderNumber);
  return instance.post(`${baseURL}/app/guardCode`, formData, {
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 列表查询接口请求
export function fetchList(params) {
  return instance.get(`${baseURL}/app/list`, {
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 查看使用记录
export function ViewUsageHistory(data) {
  const formData = new FormData();
  formData.append("pageNum", data.pageNum);
  formData.append("pageSize", data.pageSize);
  formData.append("token", data.token);
  return instance.post(`${baseURL}/app/useLog`, formData, {
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 更换账号
export function updateAccount(data) {
  const formData = new FormData();
  formData.append("token", data.token);
  formData.append("orderNumber", data.orderNumber);
  formData.append("account", data.account);
  return instance.post(`${baseURL}/app/changeAccount`, formData, {
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 找回密码
export function retrievePassword(data) {
  const formData = new FormData();
  formData.append("phone", data.phone);
  formData.append("cdk", data.cdk);
  return instance.post(`${baseURL}/app/recover`, formData, {
    headers: {
      "Content-Type": "application/json"
    }
  });
}


// 获取会员信息
export function getUserInfo(params) {
  return instance.get(`${baseURL}/app/user`, {
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
}


// 会员取号
export function getMemberOrder(data) {
  const formData = new FormData();
  formData.append("token", data.token);
  formData.append("appId", data.appId);
  return instance.post(`${baseURL}/app/getMemberOrder`, formData, {
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 查看令牌
export function getRAccount(data) {
  const formData = new FormData();
  formData.append("token", data.token);
  formData.append("orderNumber", data.orderNumber);
  return instance.post(`${baseURL}/app/getRAccount`, formData, {
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 查看令牌
export function getRGuard(data) {
  const formData = new FormData();
  formData.append("token", data.token);
  formData.append("orderNumber", data.orderNumber);
  return instance.post(`${baseURL}/app/getRGuard`, formData, {
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 获取二维码
export function getGenerateQRCode(params) {
  return instance.get(`${baseURL}/app/wechat/generateQRCode`, {
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 获取二维码登录状态
export function getLoginStatus(params) {
  return instance.get(`${baseURL}/app/wechat/checkLoginStatus`, {
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 微信绑定
export function setWechatBind(data) {
  const formData = new FormData();
  formData.append("phone", data.phone);
  formData.append("password", data.password);
  formData.append("token", data.token);
  return instance.post(`${baseURL}/app/wechatBind`, formData, {
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 微信自动登录
export function wechatLogin(params) {
  return instance.get(`${baseURL}/app/wechat/callback`, {
    params,
    headers: {
      "Content-Type": "application/json"
    }
  });
}

export function wechatPay(data) {
  const formData = new FormData();
  formData.append("token", data.token);
  formData.append("id", data.memberId);
  return instance.post(`${baseURL}/app/memberPay/create`, formData, {
    headers: {
      "Content-Type": "application/json"
    }
  });
}


export function wechatNativePay(data) {
  const formData = new FormData();
  formData.append("token", data.token);
  formData.append("id", data.memberId);
  formData.append("payType", 2);
  return instance.post(`${baseURL}/app/memberPay/createNative`, formData, {
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 获取会员价格信息
export function getMemberInfo() {
  return instance.get(`${baseURL}/app/getMemberInfo`, {
  });
}

// 获取会员价格信息
export function getWeChatStatus(params) {
  return instance.get(`${baseURL}/app/getWeChatStatus`, {
    params
  });
}


export default instance;



// WEBPACK FOOTER //
// ./src/api/index.js